import EmblaCarousel from 'embla-carousel';
const selectors = {
    productCarousel: '[data-product-gallery-carousel]',
    productCarouselViewport: '[data-product-gallery-carousel-viewport]',
    productCarouselPrev: '[data-product-gallery-carousel-prev]',
    productCarouselNext: '[data-product-gallery-carousel-next]',
};
const productGalleryCarousel = () => {
    const productCarousels = document.querySelectorAll(selectors.productCarousel);
    if (productCarousels) {
        productCarousels.forEach((carousel) => {
            const viewportNode = carousel.querySelector(selectors.productCarouselViewport);
            const prevButtonNode = carousel.querySelector(selectors.productCarouselPrev);
            const nextButtonNode = carousel.querySelector(selectors.productCarouselNext);
            const options = {
                loop: true,
                align: 'start',
            };
            const embla = EmblaCarousel(viewportNode, options);
            if (prevButtonNode && nextButtonNode) {
                prevButtonNode.addEventListener('click', () => embla.scrollPrev(), false);
                nextButtonNode.addEventListener('click', () => embla.scrollNext(), false);
            }
        });
    }
};
export { productGalleryCarousel };
